const CertifiedProduct = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="62"
            height="74"
            viewBox="0 0 62 74"
            fill="none"
            {...props}
        >
            <path
                d="M49.5705 51.5349C50.5945 50.8311 51.3728 49.8258 51.8234 48.6797C52.274 47.5335 52.3764 46.2668 52.0897 45.0603C51.7415 43.0094 51.9668 40.9183 52.7656 38.988C53.5643 37.0778 54.8956 35.4089 56.5956 34.2225C59.7497 32.051 57.763 27.8888 54.4246 25.3955C51.1066 22.9022 51.5776 18.9008 52.0897 15.9049C52.6017 12.8888 50.2464 10.7574 46.4164 10.7574C42.5863 10.7574 38.8997 11.5818 36.2371 7.76142C33.5746 3.94105 30.5638 4.42362 27.3278 6.95713C24.0917 9.49064 25.4844 11.4209 19.0533 11.0791C12.6222 10.7574 11.3728 12.748 11.0451 15.2413C10.7174 17.7346 12.3764 23.063 9.36563 25.7373C6.37536 28.3914 3.18027 30.9049 5.86333 34.9062C8.5259 38.9075 11.0451 37.7212 10.8813 42.3861C10.7174 47.051 10.5331 51.3941 13.38 52.0577C16.2269 52.7212 22.5761 50.2279 25.0748 53.063C27.5735 55.8981 30.912 60.2212 34.0866 57.8888C37.2612 55.5563 38.5925 52.8419 36.4215 51.6756C34.2504 50.5094 33.083 52.5604 38.2648 60.0604C40.8045 63.4987 42.9755 67.1783 44.7778 71.059L48.4645 62.7346L57.804 64.2427L49.6319 51.5751L49.5705 51.5349Z"
                stroke="#686058"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M43.7131 20.8914C45.6793 23.1837 46.9901 25.9383 47.5636 28.8941C48.1166 31.8499 47.8913 34.9062 46.9082 37.7413C45.1878 42.4263 41.1734 47.2118 32.0797 47.6944C13.8923 48.6997 12.049 29.3566 17.0669 22.5603C21.3065 16.7694 34.7013 10.0134 43.7336 20.8914H43.7131Z"
                stroke="#686058"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M26.0379 58.0295L17.8659 70.3552L15.2033 62.1917L5.51562 64.0214L11.8648 55.0335"
                stroke="#686058"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M27.308 37.9826L41.6449 26.5616L30.9741 33.4986C28.5573 34.6045 27.1236 35.63 22.29 31.0255L27.308 38.0027V37.9826Z"
                stroke="#686058"
                strokeWidth="2"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default CertifiedProduct
